import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { reject } from "lodash";
import { mainAxios } from "../app/api";
import service from "../config.json";
import { errorToast } from "../helpers/toaster";
const { Authorization } = JSON.parse(sessionStorage.getItem("userData")) || {};

const { getAbout, privacyCMS } = service;
//

const initialState = {
    aboutData: [],
    privacyData: [],
};

export const GetAboutAsync = createAsyncThunk(
    "cms/about",
    async (state, { rejectwithvalue }) => {
        try {
            const res = await mainAxios.get(
                getAbout,

                {
                    headers: {
                        Authorization,
                    },
                }
            );

            return res.data;
        } catch (err) {
            return rejectwithvalue(err.response.data);
        }
    }
);

export const GetPrivacyAsync = createAsyncThunk(
    "cms/privacy",
    async (state, { rejectwithvalue }) => {
        try {
            const res = await mainAxios.get(
                privacyCMS,

                {
                    headers: {
                        Authorization,
                    },
                }
            );

            return res.data;
        } catch (err) {
            return rejectwithvalue(err.response.data);
        }
    }
);

export const cmsSlice = createSlice({
    name: "cms",
    initialState,
    reducers: {},
    extraReducers: {
        [GetAboutAsync.fulfilled]: (state, { payload }) => {
            if (payload?.success === true) {
                return {
                    ...state,
                    aboutData: payload.data,
                };
            }
            if (payload?.success === false) {
                errorToast("No Data Available");
                return {
                    ...state,
                    aboutData: [],
                };
            }
        },
        [GetAboutAsync.pending]: (state) => {
            return { ...state, loading: true };
        },
        [GetAboutAsync.rejected]: (state, payload) => {
            errorToast("Something Went Wrong!");
            return { ...state, loading: false, rejected: true };
        },
        [GetPrivacyAsync.fulfilled]: (state, { payload }) => {
            if (payload?.success === true) {
                return {
                    ...state,
                    privacyData: payload.data,
                };
            }
            if (payload?.success === false) {
                errorToast("No Data Available");
                return {
                    ...state,
                    privacyData: [],
                };
            }
        },
        [GetPrivacyAsync.pending]: (state) => {
            return { ...state, loading: true };
        },
        [GetPrivacyAsync.rejected]: (state, payload) => {
            errorToast("Something Went Wrong!");
            return { ...state, loading: false, rejected: true };
        },
    },
});

// Action creators are generated for each case reducer function
export const { adultInc } = cmsSlice.actions;

export default cmsSlice.reducer;
